import { render } from "./SvgBurgerIcon.vue?vue&type=template&id=0d3571ba"
import script from "./SvgBurgerIcon.vue?vue&type=script&lang=js"
export * from "./SvgBurgerIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__